"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("../Themes/styled-components"));

var Wrapper = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"], ["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"])), function (_a) {
  var scWidth = _a.scWidth,
      scHeight = _a.scHeight;
  return 100 / (scWidth / scHeight);
});
var Content = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));

var PictureFrame =
/** @class */
function (_super) {
  __extends(PictureFrame, _super);

  function PictureFrame() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PictureFrame.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        width = _a.width,
        height = _a.height,
        children = _a.children;
    return React.createElement(Wrapper, {
      className: className,
      scWidth: width,
      scHeight: height
    }, React.createElement(Content, null, children));
  };

  return PictureFrame;
}(React.PureComponent);

exports.PictureFrame = PictureFrame;
exports.default = PictureFrame;
var templateObject_1, templateObject_2;